/**
 * CG-611/CG-749: the shared record-key rule for sub-geometry splits.
 *
 * A request's record key is `agencySubGeometryId ?? null` — one key per sub-geometry the
 * agency's requests were routed to, plus `null` for the agency-level catch-all covering
 * the remaining project area. Region numbering on every surface (customer Utilities
 * table, admin request details) is the key's position in this list, so all surfaces must
 * derive it identically: distinct keys in first-appearance order, with the catch-all
 * forced last — "Region M of M — remaining area", per CG-749.
 */
export function collectRecordKeys(requests: { agencySubGeometryId?: string | null }[]): (string | null)[] {
  const keys: (string | null)[] = [];
  let hasCatchAll = false;
  for (const request of requests) {
    const key = request.agencySubGeometryId ?? null;
    if (key === null) hasCatchAll = true;
    else if (!keys.includes(key)) keys.push(key);
  }
  if (hasCatchAll) keys.push(null);
  return keys;
}
